module.exports = __webpack_public_path__ + "static/media/Aveny soffa D32R zink 3493 detalj 2023 3.826e4ca1.jpg";